module.exports = __webpack_public_path__ + "static/media/checkbox-sign-in-widget@2x.c8c02700.png";